import React from 'react';

const ConfigSystemFormModal = React.lazy(() => import('../components/FormModal'));
const configSystemModalRegistry = {
    crm_configSystemId: ConfigSystemFormModal
};
export default configSystemModalRegistry;
